import { Injectable } from '@angular/core';
import { ISectionRightsService } from '@shared/services/rights';

import type { SectionRight } from '@shared/services/rights';

/**
 * Adaptateur BackStage du port `ISectionRightsService` du kit.
 *
 * Les « droits par section » sont une notion du **Manager** : ils decoupent son
 * interface (catalogue, plans, tarifs, parametrage) a partir de claims
 * `USERRIGHT_*`. BackStage ne les connait pas — son controle d'acces passe par
 * `RolesUtilisateurService` et les guards de route, sur des roles applicatifs
 * differents (Admin / Compta / Tech / ServiceClient).
 *
 * ## Il n'accorde RIEN — et c'est volontaire
 *
 * Un port d'autorisation qui repond « oui » par defaut est un trou en attente
 * d'un consommateur. Cet adaptateur n'accorde donc AUCUN droit. Verifie que
 * c'est sans effet de bord sur BackStage :
 *
 * - **Barre de navigation** : `filterNavigationByRights` passe par
 *   `isPathAllowed`, qui autorise tout chemin ABSENT de `SECTION_ACCESS`
 *   (`requiredRightsForPath` rend `[]`, et `holdsAnyRight([], …)` est vrai). Les
 *   6 chemins de `NAVIGATION_BACKSTAGE` (`/clients/…`, `/redditions/…`,
 *   `/rapprochement/…`, `/parametrage/…`) n'y figurent pas : ils restent
 *   visibles. Ce sont les roles Azure, dans `AppComponent.calculerNavigation`,
 *   qui les filtrent reellement.
 * - **Tiroirs** : les 6 chemins de `DRAWER_SECTION_PATH` (`/orders`,
 *   `/customers`, `/subscriptions`, `/events`, `/mise-en-vente`,
 *   `/catalog-plan`) sont, eux, tous references dans `SECTION_ACCESS` : leur
 *   `canOpen` devient donc `false`. C'est le comportement voulu — BackStage
 *   n'expose aucun tiroir. Le port n'existe que pour que la chaine
 *   `DrawerStackStore -> DRAWER_REGISTRY -> SECTION_RIGHTS_SERVICE` resolve,
 *   parce que le conteneur de toasts en depend.
 * - **`FeatureFlagAdmin`** : console d'administration inter-locataires du
 *   Manager, absente de BackStage. Refusee comme le reste, donc pas d'entree de
 *   menu vers une route inexistante.
 *
 * Le jour ou BackStage adopte les tiroirs ou une section du kit, l'echec sera
 * VISIBLE (l'ecran ne s'ouvre pas) au lieu d'etre permissif : c'est ici qu'il
 * faudra brancher une vraie traduction roles BackStage -> sections.
 */
@Injectable({ providedIn: 'root' })
export class SectionRightsBackstageService extends ISectionRightsService {
  getRights(): readonly SectionRight[] {
    return [];
  }

  hasRight(_right: SectionRight): boolean {
    return false;
  }
}
